import ApiService from '../../apis/ApiService';

const chunkSize = 1024 * 1024 * 5;
const URL = '/api/video';

const genID = (length) => {
  let result = '';
  let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getChunkAPI = (file) => {
  const filename = `${new Date().getTime()}-${genID(10)}`;
  // const request = new XMLHttpRequest();
  // request.overrideMimeType('application/octet-stream');

  let currentChunkStartByte = 0;
  let currentChunkFinalByte = chunkSize > file.size ? file.size : chunkSize;

  const uploadFile = (callbackCheck, progress) => {
    const formData = new FormData();
    const chunk = file.slice(currentChunkStartByte, currentChunkFinalByte);
    formData.append('media', chunk, filename);

    ApiService.post(URL, {
      headers: {
        'Content-Range': `bytes ${currentChunkStartByte}-${currentChunkFinalByte}/${file.size}`,
      },
      data: formData,
      withCredentials: true,
      timeout: 0,
    })
      .then(({ data }) => {
        const remainingBytes = file.size - currentChunkFinalByte;

        if (currentChunkFinalByte === file.size) {
          const { uniqid, url: fileUrl, path: filePath } = data;
          progress(100);
          callbackCheck({
            uniqid,
            url: fileUrl,
            path: filePath,
            filename,
          });
          return;
        } else if (remainingBytes < chunkSize) {
          currentChunkStartByte = currentChunkFinalByte;
          currentChunkFinalByte = currentChunkStartByte + remainingBytes;
        } else {
          currentChunkStartByte = currentChunkFinalByte;
          currentChunkFinalByte = currentChunkStartByte + chunkSize;
        }

        progress(currentChunkFinalByte / file.size);
        uploadFile(callbackCheck, progress);
      })
      .catch((err) => {
        console.error(err);
        callbackCheck(false);
      });
  };

  return { uploadFile };
};
